var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50332 13.7495C9.62046 13.7495 9.73202 13.7256 9.83322 13.6826C9.93601 13.6388 10.0277 13.5758 10.1049 13.4977L15.2016 8.40107C15.5339 8.06879 15.5339 7.53091 15.2016 7.19862C14.8701 6.86713 14.3314 6.86713 13.9999 7.19862L10.351 10.8483V1.85026C10.351 1.3809 9.97014 1 9.50079 1C9.03143 1 8.65053 1.3809 8.65053 1.85026V10.8483L5.00166 7.19862C4.67016 6.86713 4.13149 6.86713 3.8 7.19862C3.46771 7.53091 3.46771 8.06879 3.8 8.40107L8.8999 13.501C8.98277 13.5846 9.07919 13.6468 9.18278 13.6882C9.2784 13.7273 9.38359 13.7488 9.49275 13.7496L9.50332 13.7495Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.70051 12.9C2.70051 12.4306 2.31961 12.0497 1.85026 12.0497C1.3809 12.0497 1 12.4306 1 12.9V15.4499C1 16.858 2.14191 17.9999 3.54995 17.9999H15.4503C16.8583 17.9999 18.0002 16.858 18.0002 15.4499V12.9C18.0002 12.4306 17.6193 12.0497 17.15 12.0497C16.6806 12.0497 16.2997 12.4306 16.2997 12.9V15.4499C16.2997 15.9193 15.9196 16.2994 15.4502 16.2994H3.54993C3.08057 16.2994 2.70047 15.9193 2.70047 15.4499L2.70051 12.9Z",
    fill: "#3C7AF5",
    stroke: "#3C7AF5",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.4b03e4994453506c77f36b028b3f5a7c.svg";
export { ForwardRef as ReactComponent };